import { ReactNode } from 'react';

import round from 'lodash/round';

import { compactNumber, dashesOrNum } from '@cast/utils';

const COMPACT_NUMBER_THRESHOLD = 1_000_000;

const formatWithDotThousands = (
  value: number,
  options: Intl.NumberFormatOptions
): string =>
  new Intl.NumberFormat('en-US', options)
    .formatToParts(value)
    .map((part) => (part.type === 'group' ? '.' : part.value))
    .join('');

const formatFleetNumber = (value: number, fractionDigits?: number): string => {
  if (Math.abs(value) >= COMPACT_NUMBER_THRESHOLD) {
    return compactNumber(value, { maximumFractionDigits: 1 });
  }

  if (fractionDigits !== undefined) {
    return formatWithDotThousands(round(value, fractionDigits), {
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
      useGrouping: false,
    });
  }

  return formatWithDotThousands(Math.round(value), {
    maximumFractionDigits: 0,
    useGrouping: true,
  });
};

export const formatFleetMetricNumber = (
  value: number,
  fractionDigits?: number
): ReactNode =>
  dashesOrNum({
    value,
    decimals: fractionDigits ?? 0,
    mapNumber: (num) => formatFleetNumber(num, fractionDigits),
  });
